import { platformCarriersBanner } from '@/config/carriers/carriersConfig'
import CustomImage from 'src/components/Image'
import useI18n from 'src/hooks/use_i18n'
import styles from './index.module.scss'

export default function Banner() {
  const { activeLocale: locale, $t, i18nFormatAll } = useI18n()

  return (
    <section className={styles.banner}>
      <h2>{i18nFormatAll($t('ResWwwPlatform.global.__DetailBannerH2'), { carriersnumber: 2500 })}</h2>
      <div className={styles.secondStep}>
        <div>
          <div className={styles.carrierLine}>
            {platformCarriersBanner.map((code, index) => {
              const style: any = { '--i': index + 1, '--n': platformCarriersBanner.length }
              return (
                <div className={styles.carrier} key={index} style={style}>
                  <CustomImage
                    loading="lazy"
                    width={64}
                    height={64}
                    className="lazy-image-fill"
                    isWebp={false}
                    src={`https://res.17track.net/asset/carrier/logo/120x120/${code}`}
                    alt={`${code}`}
                    errorSrc="https://res.17track.net/asset/carrier/logo/120x120/0"
                  />
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <button>
        <a href={`https://www.17track.net/${locale}/carriers`}>{$t('ResWwwPlatform.global.__DetailBannerBtn')}</a>
      </button>
    </section>
  )
}
